import { DateTime } from 'luxon'

const TZ_LABELS = {
    'America/New_York': 'Eastern Time',
    'America/Chicago': 'Central Time',
    'America/Denver': 'Mountain Time',
    'America/Los_Angeles': 'Pacific Time',
    'America/Phoenix': 'Mountain Time (Arizona)',
    'America/Anchorage': 'Alaska Time',
    'America/Adak': 'Hawaii-Aleutian Time',
    'Pacific/Honolulu': 'Hawaii Time',
    'America/Puerto_Rico': 'Atlantic Time',
    'UTC': 'UTC',
    'Etc/UTC': 'UTC',
}

export const BOOKING_TIMEZONES = [
    'UTC', 'America/New_York', 'America/Chicago', 'America/Denver', 'America/Los_Angeles',
    'America/Phoenix', 'America/Anchorage', 'America/Adak', 'Pacific/Honolulu',
]

export function toScheduledAtISO(dt) {
    return dt.toUTC().toISO({ suppressSeconds: true, suppressMilliseconds: true })
}

export function toE164Phone(digits) {
    const cleaned = String(digits || '').replace(/\D/g, '')
    return cleaned ? `+1${cleaned}` : ''
}

export function normalizeTimeZone(tz) {
    if (!tz) return 'UTC'
    if (TZ_LABELS[tz]) return TZ_LABELS[tz]
    try {
        const parts = Intl.DateTimeFormat('en', { timeZoneName: 'longGeneric', timeZone: tz })
            .formatToParts(new Date())
        return parts.find(p => p.type === 'timeZoneName')?.value || tz
    } catch {
        return tz
    }
}

const PAYMENT_METHOD_LABELS = {
    inPerson: 'In Person',
    online: 'Online',
}

export function formatPaymentMethod(method) {
    if (!method) return '—'
    return PAYMENT_METHOD_LABELS[method] || method
}

export function bookingTzNote(booking, merchantTz) {
    const scheduledAt = booking?.scheduledAt
    const bookingTz = booking?.timeZone
    if (!scheduledAt || !bookingTz || !merchantTz || bookingTz === merchantTz) return ''
    try {
        const dt = DateTime.fromISO(scheduledAt, { zone: 'utc' }).setZone(bookingTz)
        if (!dt.isValid) return ''
        return `${dt.toFormat('h:mm a')} ${normalizeTimeZone(bookingTz)}`
    } catch {
        return ''
    }
}
